import React from "react";
import { DialogContextType } from "./types";

export function createDialogContextBundle<T>() {
  const DialogContext = React.createContext<DialogContextType<T>>({
    openDialog: () => {},
    closeDialog: () => {},
    id: "",
  });

  function useDialogContext() {
    return React.useContext(DialogContext);
  }

  return { DialogContext, useDialogContext };
}
